import { isThirdPartyIntegrations } from 'app/policies/config';
import { USER_ROLES } from 'app/services/users.service';

function canPermissions(user) {
  return user?.role_guid !== USER_ROLES.publisher && !isThirdPartyIntegrations(user);
}

export function permissionsRol(user) {
  return {
    readList: canPermissions(user),
    readDetail: canPermissions(user),
    create: canPermissions(user),
    update: canPermissions(user),
    delete: canPermissions(user),
  };
}
